(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    

window.addEventListener('load', (event) => {
  var $sidebar = document.querySelector('.CollectionInner__Sidebar');
  var $hideFilter = document.querySelector('.CollectionToolbar__Item--hideFilter');
  var $inner = document.querySelector('.js-CollectionInner');

  if ($hideFilter && $sidebar && $inner) {
      $hideFilter.addEventListener('click', function() {
          if ($sidebar.classList.contains('hidden')) {
              $sidebar.classList.remove('hidden');
			  $hideFilter.classList.add('active');
			  $inner.classList.add('filterActive');
          } else {
              $sidebar.classList.add('hidden');
			  $hideFilter.classList.remove('active');
			  $inner.classList.remove('filterActive');
          }
      })
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

window.addEventListener('load', (event) => {
	var $toggleDetails = document.querySelector('.js-Collapsible__ToggleDetails');
	var $desc = document.querySelector('.js-Collapsible__Content--desc');

	if ($toggleDetails) {

      $toggleDetails.addEventListener('click', function() {

          if ($desc.classList.contains('show')) {
              $toggleDetails.classList.remove('details-showing');
              $desc.classList.remove('show');
          } else {
              $toggleDetails.classList.add('details-showing');
              $desc.classList.add('show');
          }
      });

	}
});



  } catch(e) { console.error(e); }
})();
})();
